import FixaButton from "@coworker/apprestructured/src/shared/wrappers/FixaButton/FixaButton";
import { useToastNotification } from "@coworker/components/src/components/ToastNotification";
import { useTranslation } from "@coworker/locales";
import CopyIconPath from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/paths/CopyIconPath";

interface CopyToClipboardButtonProps {
  valueForClipboard: string;
  onClick: () => void;
  /** When provided, called instead of the global toast (e.g. inside a modal). */
  onCopy?: () => void;
}

export const CopyToClipboardButton = ({
  valueForClipboard,
  onClick,
  onCopy,
}: CopyToClipboardButtonProps) => {
  const { t } = useTranslation();
  const { showToast } = useToastNotification();

  return (
    <FixaButton
      ssrIcon={CopyIconPath}
      onClick={() => {
        onClick();
        navigator.clipboard.writeText(valueForClipboard);
        if (onCopy) {
          onCopy();
        } else {
          showToast(t("artileNumberCopiedToCliboardString"));
        }
      }}
      iconOnly
      type="tertiary"
      data-testid={`copyToClipboardButton-${valueForClipboard}`}
      size="xsmall"
    />
  );
};
